import { Tag } from '../../Context/dist/effect-Context.esm.js';
import { equals } from '../../Equal/dist/effect-Equal.esm.js';
import { pipe } from '../../Function/dist/effect-Function.esm.js';
import { map, flatMap, forEachSequential, sync, succeed } from '../../internal/core.esm.js';
import { descriptorWith } from '../../internal/core-effect.esm.js';
import { Order } from '../../internal/fiber.esm.js';
import { get as get$2 } from '../../MutableRef/dist/effect-MutableRef.esm.js';
import { reduce } from '../../ReadonlyArray/dist/effect-ReadonlyArray.esm.js';
import { get, update } from '../../Ref/dist/effect-Ref.esm.js';
import { filter, empty, union } from '../../SortedSet/dist/effect-SortedSet.esm.js';
import { fibers } from '../../TestAnnotation/dist/effect-TestAnnotation.esm.js';
import { get as get$1, annotate } from '../../TestAnnotationMap/dist/effect-TestAnnotationMap.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */
const TestAnnotationsTypeId = /*#__PURE__*/Symbol.for("effect/TestAnnotations");

/**
 * @since 2.0.0
 */

/**
 * The `Annotations` trait provides access to an annotation map that tests can
 * add arbitrary annotations to. Each annotation consists of a string
 * identifier, an initial value, and a function for combining two values.
 * Annotations form monoids and you can think of `Annotations` as a more
 * structured logging service or as a super polymorphic version of the writer
 * monad effect.
 *
 * @since 2.0.0
 */

/** @internal */
class AnnotationsImpl {
  [TestAnnotationsTypeId] = TestAnnotationsTypeId;
  constructor(ref) {
    this.ref = ref;
  }
  get(key) {
    return map(get(this.ref), get$1(key));
  }
  annotate(key, value) {
    return update(this.ref, annotate(key, value));
  }
  supervisedFibers() {
    return descriptorWith(descriptor => flatMap(this.get(fibers), either => {
      switch (either._tag) {
        case "Left":
          {
            return succeed(empty(Order));
          }
        case "Right":
          {
            return pipe(either.right, forEachSequential(ref => sync(() => get$2(ref))), map(reduce(empty(Order), (a, b) => union(a, b))), map(filter(fiber => !equals(fiber.id(), descriptor.id))));
          }
      }
    }));
  }
}

/**
 * @since 2.0.0
 */
const TestAnnotations = /*#__PURE__*/Tag( /*#__PURE__*/Symbol.for("effect/Annotations"));

/**
 * @since 2.0.0
 */
const isTestAnnotations = u => {
  return typeof u === "object" && u != null && TestAnnotationsTypeId in u;
};

/**
 * @since 2.0.0
 */
const make = ref => new AnnotationsImpl(ref);

export { TestAnnotations, TestAnnotationsTypeId, isTestAnnotations, make };
